import React from "react";
import "../../App.css";
import QuotationForm from "../QuotationForm";

function QuotationPage({ sessionObject }) {
  if (!sessionObject.sessionVariables["modules"].includes("quotation")) {
    return;
  }
  return (
    <div className="page-challan">
      <QuotationForm sessionObject={sessionObject} />
    </div>
  );
}

export default QuotationPage;
